// @flow

import React, { Component } from 'react';
import cx from 'classnames';
import DeleteModal from './DeleteModal';

type Props = {
  content: string | Element,
  modalTitle?: string,
  modalContent: string,
  className?: string,
  isLoading?: boolean,
  icon?: Element,
  onConfirm: () => void,
};

type State = {
  modalOpen: boolean,
};

class ConfirmDeleteButton extends Component {
  props: Props;
  state: State;

  static defaultProps = {
    isLoading: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      modalOpen: false,
    };
  }

  showModal = (evt: SyntheticEvent) => {
    evt.preventDefault();
    evt.stopPropagation();

    this.setState({ modalOpen: true });
  };
  closeModal = () => this.setState({ modalOpen: false });

  render() {
    const {
      content,
      modalTitle,
      modalContent,
      className,
      isLoading,
      icon,
      onConfirm,
    } = this.props;
    const { modalOpen } = this.state;

    const buttonClass = cx('ui button', className);
    const open = modalOpen || !!isLoading;

    return (
      <button className={buttonClass} onClick={this.showModal}>
        {content}
        {icon}
        <DeleteModal
          open={open}
          loading={isLoading}
          title={modalTitle}
          content={modalContent}
          onConfirm={onConfirm}
          onClose={this.closeModal}
        />
      </button>
    );
  }
}

export default ConfirmDeleteButton;



// WEBPACK FOOTER //
// ./src/shared/components/ConfirmDeleteButton.js